// eslint-disable-next-line no-restricted-syntax
export enum GlossaryProp {
  HITS = 'hits',
  ANYTIME_TOUCHDOWNS = 'anytime_touchdowns',
}
